import { useRecoilState } from 'recoil';
import { CSSProperties, FunctionComponent, useEffect, useState } from 'react';
import { hudPillAtom } from 'packages/at-shell/state/recoil/ui';
import { theme } from 'antd';

const placementStyles: Record<string, CSSProperties> = {
  top: {
    top: 0,
    right: '50%',
    transform: 'translateX(50%)',
  },
  topLeft: {
    top: 0,
    left: 0,
  },
  topRight: {
    top: 0,
    right: 0,
  },
  bottomRight: {
    bottom: 0,
    right: 0,
  },
};

export const PillHud: FunctionComponent<
  React.PropsWithChildren<{
    placement: keyof typeof placementStyles;
  }>
> = ({ placement }) => {
  const { token } = theme.useToken();
  const [value, setValue] = useRecoilState(hudPillAtom);
  const [prevValue, setPrevZoom] = useState(value); // when prevZoom and zoom are equal, countdown to fadeout
  const [visible, setVisible] = useState(false); // fadeout to zero opacity when (visible === false)
  const [hidden, setHidden] = useState(true); // delay so we can fadeout, then return null when (hidden === true)
  useEffect(() => {
    setPrevZoom(value);
    setVisible(true);
    setHidden(false);
    // after 1s, if zoom % has not changed, fade out the zoom % indicator
    const timeoutId = setTimeout(() => {
      if (prevValue === value) {
        setVisible(false);
        // set hidden after element fades to 0 opacity
        setTimeout(() => {
          if (prevValue === value) {
            setHidden(true);
            setValue('');
          }
        }, 250);
      }
    }, 1750);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [value, prevValue, setValue]);
  const hide = !value || hidden;
  if (hide) {
    return null;
  }
  return (
    <div
      style={{
        position: 'absolute',
        ...placementStyles[placement],
        padding: '8px',
        zIndex: 2,
        minWidth: '8rem',
      }}
    >
      <div
        style={{
          height: '2.25rem',
          minWidth: '8rem',
          borderRadius: '1.25rem',
          padding: '0.5rem 0.8rem',
          color: token.colorText,
          background: token.colorBgBase,
          transition: 'opacity 250ms linear',
          opacity: visible ? 0.8 : 0,
          textAlign: 'center',
          fontSize: '1rem',
        }}
      >
        {value}
      </div>
    </div>
  );
};
